import { render } from "./ChampionshipsRequests.vue?vue&type=template&id=7430c210"
import script from "./ChampionshipsRequests.vue?vue&type=script&lang=js"
export * from "./ChampionshipsRequests.vue?vue&type=script&lang=js"

import "./ChampionshipsRequests.vue?vue&type=style&index=0&id=7430c210&lang=css"

import exportComponent from "D:\\Abdullah\\Projects\\R-Sport\\System\\rsport_dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__